import{ useState } from "react";
import './ImageCollage.css'

const ImageCollage = ({ images }) => {
  const count = images.length;
  const [openIndex, setOpenIndex] = useState(null);

  if (count === 0) return null;

  // Zmniejszamy kolaż o 20%:
  const containerBaseStyle = {
    width: "72%",       // 90% * 0.8 = 72%
    height: "300px",    // 500px * 0.8 = 400px
    margin: "auto",
    gap: "6px",
    overflow: "hidden",
    borderRadius: 4,
    position: "relative",
  };

  const renderImage = (img, idx, styleOverrides = {}) => (
    <div
      key={idx}
      style={{
        overflow: "hidden",
        borderRadius: 4,
        height: "100%",
        cursor: "pointer",
        ...styleOverrides,
      }}
      onClick={() => setOpenIndex(idx)}
    >
      <img
        src={img.uploadedUrl}
        alt={`img-${idx}`}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </div>
  );

  // Powiększamy modal o 30%:
const renderModal = () => {
  if (openIndex === null) return null;
  const img = images[openIndex];
  return (
    <div
      style={{
        position: "fixed",           // fixed na cały ekran
        top: 0,
        left: 0,
        width: "100vw",             // pełna szerokość viewportu
        height: "100vh",            // pełna wysokość viewportu
        backgroundColor: "rgba(0, 0, 0, 0.88)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={() => setOpenIndex(null)}  // klik na tło zamyka modal
    >
      <div
        style={{
          position: "relative",
          maxWidth: "146%",  // 117% * 1.25 ≈ 146%
          maxHeight: "146%",
        }}
        onClick={(e) => e.stopPropagation()} // zapobiega zamknięciu po kliknięciu w obraz
      >
        <img
          className="BigImageZoomed"
          src={img.uploadedUrl}
          alt={`img-large-${openIndex}`}
        />
        <button
          onClick={() => setOpenIndex(null)}
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            background: "rgba(255,255,255,0.8)",
            border: "none",
            borderRadius: "50%",
            width: 30,
            height: 30,
            fontWeight: "bold",
            cursor: "pointer",
          }}
          aria-label="Close image"
        >
          ×
        </button>
      </div>
    </div>
  );
};
  if (count === 1) {
    return (
      <div
        style={{
          ...containerBaseStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {renderImage(images[0], 0, { width: "60%", height: "100%" })}
        {renderModal()}
      </div>
    );
  }

  if (count === 2) {
    return (
      <div
        style={{
          ...containerBaseStyle,
          display: "flex",
          gap: "6px",
          height: "250px"
        }}
      >
        {images.map((img, idx) => renderImage(img, idx, { flex: 1 }))}
        {renderModal()}
      </div>
    );
  }

  if (count === 3) {
    return (
      <div
        style={{
          ...containerBaseStyle,
          display: "grid",
          gridTemplateColumns: "60% 40%",
          gridTemplateRows: "50% 50%",
          gap: "6px",
        }}
      >
        {renderImage(images[0], 0, { gridColumn: "1 / 2", gridRow: "1 / 3" })}
        {renderImage(images[1], 1, { gridColumn: "2 / 3", gridRow: "1 / 2" })}
        {renderImage(images[2], 2, { gridColumn: "2 / 3", gridRow: "2 / 3" })}
        {renderModal()}
      </div>
    );
  }

  if (count === 4 || count === 5) {
    return (
      <div
        style={{
          ...containerBaseStyle,
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gridTemplateRows: "repeat(2, 1fr)",
          gap: "6px",
        }}
      >
        {renderImage(images[0], 0, { gridColumn: "span 2", gridRow: "span 2" })}
        {renderImage(images[1], 1, { gridColumn: "3", gridRow: "1" })}
        {renderImage(images[2], 2, { gridColumn: "4", gridRow: "1" })}
        {renderImage(images[3], 3, { gridColumn: "3", gridRow: "2" })}
        {count === 5 &&
          renderImage(images[4], 4, { gridColumn: "4", gridRow: "2" })}
        {renderModal()}
      </div>
    );
  }

  // fallback
  return (
    <div style={{ ...containerBaseStyle, display: "flex" }}>
      {images.map((img, idx) => renderImage(img, idx))}
      {renderModal()}
    </div>
  );
};

export default ImageCollage;